import { gql, TypedDocumentNode } from '@apollo/client';
import type { PurchaseOrder } from '../models/PurchaseOrder';

export const GET_PURCHASEORDERS_QUERY: TypedDocumentNode<{ purchaseOrders: PurchaseOrder[] }> = gql`
  query GetPurchaseOrders {
    purchaseOrders(order: { id: DESC }) {
      id,
      dateTimePurchased,
      inventoryItems {
        id,
        quantityOnHand,
        quantityOrdered,
        costPerUnit,
        lotNumber,
        surchargePerUnit,
        shippingCostPerUnit,
        orderDetails,
        totalCostPerUnit,
        totalOrderedCost,
        itemId,
        item {
          id,
          name,
          unitType,
          isIngredient,
          description,
          orderNotes,
          standardShippingQuantity,
          minOrderQuantity,
          maxOrderQuantity,
          lowStock,
          outOfStock
        },
        vendorId,
        vendor {
          id,
          name
        }
      },
      vendorId,
      vendor {
        id,
        name
      },
      totalOrderCost
    }
  }
`;

export const GET_PURCHASEORDER_BY_ID_QUERY: TypedDocumentNode<{ purchaseOrder: PurchaseOrder }, { id: number }> = gql`
  query GetPurchaseOrderById($id: Int!) {
    purchaseOrder: purchaseOrderById(id: $id) {
      id,
      dateTimePurchased,
      inventoryItems {
        id,
        quantityOnHand,
        quantityOrdered,
        costPerUnit,
        lotNumber,
        surchargePerUnit,
        shippingCostPerUnit,
        orderDetails,
        totalCostPerUnit,
        totalOrderedCost,
        itemId,
        item {
          id,
          name,
          unitType,
          isIngredient,
          description,
          orderNotes,
          standardShippingQuantity,
          minOrderQuantity,
          maxOrderQuantity,
          lowStock,
          outOfStock
        },
        vendorId,
        vendor {
          id,
          name
        },
        purchaseOrderId,
        purchaseOrder {
          id,
          dateTimePurchased
        }
      },
      vendorId,
      vendor {
        id,
        name
      },
      totalOrderCost
    }
  }
`;
